import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, List, Typography } from '@mui/material';
import { KeyboardShortcutsItem } from 'pages/keyboard-shortcuts/ui/keyboard-shortcuts-item';
export function KeyboardShortcutsList({ keyboard_shortcuts_data, }) {
    return (_jsx(Box, { width: "100%", children: keyboard_shortcuts_data.map((item) => (_jsxs(Box, { children: [_jsx(Typography, { children: item.title }), _jsx(List, { children: item.shortcuts.map((shortcut) => (_jsx(KeyboardShortcutsItem, { shortcut: shortcut }, shortcut.key))) })] }, item.title))) }));
}
